const MIN_TOKEN_LENGTH = 21;

export function isUsableBearerToken(token: string | null | undefined): token is string {
  return typeof token === "string" && token.length >= MIN_TOKEN_LENGTH;
}

/** Read bearer token from this window, or copy from opener when opened via Ctrl+click help detail. */
export function readBearerTokenForHelpDetail(): string | null {
  const localToken = window.sessionStorage.getItem("BearerToken");
  if (isUsableBearerToken(localToken)) return localToken;

  try {
    const opener = window.opener;
    if (!opener || opener.closed) return null;

    const openerToken = opener.sessionStorage.getItem("BearerToken");
    if (!isUsableBearerToken(openerToken)) return null;

    window.sessionStorage.setItem("BearerToken", openerToken);
    return openerToken;
  } catch {
    return null;
  }
}
